import type { Staff } from "@/lib/authv2/store";
import { ACTION } from "@/lib/auth/actions";
import { hasPermission } from "@/lib/authv2/permissions";
import { canReadPayroll } from "@/features/payroll/permissions";

// Ai vào được trang Đánh giá (điểm khách chấm ê-kíp): người đọc được lương
// (như trước) HOẶC người có review.read trong JWT — trưởng cửa hàng và QC
// (spec 2026-08-23 §5.7). BE cắt dữ liệu theo cơ sở (TCH) và theo phòng (QC),
// FE chỉ quyết có mở trang hay không.
export function canReadQuality(staff: Staff | null): boolean {
  if (!staff) return false;
  return canReadPayroll(staff) || hasPermission(ACTION.ReviewRead);
}
